import { struct } from 'io-ts/Decoder';

import { Id } from '../../../../../user/preferences/ui-settings-template/Id';

export const Param = struct({
	id: Id,
});
